import { getCookieByName } from 'utils/getCookieByName';
import { isDevDomain, isFandomCom, isPLDevDomain } from 'utils/env';
export const ACTIVE_NOTIFICATION_COOKIE = 'active_cms_notification';
export const getActiveNotification = (allActiveNotifications) => {
    const activeNotificationId = getCookieByName(ACTIVE_NOTIFICATION_COOKIE);
    if (activeNotificationId) {
        return allActiveNotifications.find(({ id }) => id.toString() === activeNotificationId);
    }
    return null;
};
export const getActiveNotificationIdFromCookie = () => {
    return getCookieByName(ACTIVE_NOTIFICATION_COOKIE);
};
const getCookieDomain = () => {
    let domain = isFandomCom() ? 'fandom.com' : '';
    if (!domain && isDevDomain()) {
        domain = isPLDevDomain() ? 'fandom-dev.pl' : 'fandom-dev.us';
    }
    return domain;
};
export const setActiveNotificationCookie = (notificationId) => {
    // eslint-disable-next-line regex/invalid
    document.cookie = `${ACTIVE_NOTIFICATION_COOKIE}=${notificationId}; path=/; domain=.${getCookieDomain()}`;
};
